import { useState } from "react";
import { hotTags, navItems, riskIndex } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* utility strip */}
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-4 text-[11px] md:text-xs">
            <span className="hidden items-center gap-1.5 sm:flex">
              <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
              2026年9月12日 星期六
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
              数据更新 {riskIndex.updated.slice(11)}
            </span>
          </div>
          <div className="flex items-center gap-4 text-[11px] md:text-xs">
            <span className="hidden items-center gap-1.5 md:flex">
              今日风险指数
              <strong className="text-accent-400">{riskIndex.score}</strong>
              <span className="text-primary-400">{riskIndex.level}</span>
            </span>
            <a
              href="#subscribe"
              className="flex items-center gap-1 whitespace-nowrap text-accent-400 hover:text-accent-300"
            >
              <i className="ri-notification-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
              订阅预警
            </a>
          </div>
        </div>
      </div>

      {/* main bar */}
      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-4 px-4 md:h-[74px] md:px-6">
          <a href="#top" className="flex shrink-0 items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50 md:h-11 md:w-11 md:text-xl">
              17
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
                17黑料网
              </h1>
              <span className="mt-0.5 hidden text-[11px] text-foreground-500 sm:block">
                代言风险 · 合作避雷 · 舆情跟踪
              </span>
            </span>
          </a>

          <nav className="hidden flex-1 items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={`#${item.key}`}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto hidden items-center gap-3 md:flex">
            <div className="relative">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 flex items-center justify-center text-sm text-foreground-400"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                type="text"
                placeholder="搜索艺人 / 品牌 / 事件"
                className="w-44 rounded-md border border-background-300 bg-background-100 py-2 pl-9 pr-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:bg-background-50 lg:w-56"
              />
            </div>
            <a
              href="#subscribe"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-radar-line w-4 h-4 flex items-center justify-center"></i>
              风险预警
            </a>
          </div>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-2-line"} text-xl`}></i>
          </button>
        </div>

        {/* hot tags strip */}
        <div className="border-t border-background-200 bg-background-100/70">
          <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-2 md:px-6">
            <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              热搜词
            </span>
            <div className="no-scrollbar flex flex-1 gap-2 overflow-x-auto">
              {hotTags.map((tag) => (
                <span
                  key={tag}
                  className="whitespace-nowrap rounded-full bg-background-50 px-2.5 py-1 text-xs text-foreground-600 ring-1 ring-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* mobile panel */}
        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <a
                  key={item.key}
                  href={`#${item.key}`}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md bg-background-100 px-3 py-2.5 text-center text-sm font-medium text-foreground-800"
                >
                  {item.label}
                </a>
              ))}
            </div>
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 block rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-semibold text-background-50"
            >
              订阅风险预警
            </a>
          </div>
        )}
      </div>
    </header>
  );
}